import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Main from "components/UI/Main";
import * as yup from "yup";
import MDTypography from "components/MDTypography";
import UpdateRecord from "helpers/compare";
import { Icon } from "@mui/material";
import PropTypes from "prop-types";
import PagesCount from "helpers/pages-count";

import {
  addComplexDataAction,
  fetchDataAction,
  deleteDataAction,
  reset,
} from "../../store/features/coreSlice";
import dataVal from "./dataVal.json";

const CelebrityProducts = ({ celebrityId }) => {
  const dispatch = useDispatch();

  const { celebrityProductsMeta, celebrityProducts, resStatus, celeAllProducts, limit } =
    useSelector((state) => state.core);

  const [newArr, setNewArr] = useState([]);
  const [data, setData] = useState([]);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(false);
  const [pageNum, setPageNum] = useState(1);
  const [pageOptions, setPageOption] = useState([]);

  const [initialValues, setInitialValues] = useState({
    product_id: null,
    sequence: 0,
    celebrity_id: celebrityId,
  });

  const orgData = () => {
    setData([
      {
        type: "Select",
        optionTitle: "arabic_title",
        name: "product_id",
        id: "product_id",
        label: "product_id",
        data: celeAllProducts,
        size: 6,
        title: "Product",
      },
      {
        type: "TextField",
        name: "sequence",
        id: "sequence",
        label: "sequence",
        size: 6,
        title: "Sequence",
      },
    ]);
  };

  const onUpdateHandler = (name, values) => {
    setInitialValues({
      id: values.id,
      product_id: values.product_id,
      sequence: values.sequence,
    });
  };

  const resetForm = () => {
    setInitialValues({
      product_id: null,
      sequence: 0,
      celebrity_id: celebrityId,
    });
    orgData();
  };

  const onDeleteHandler = (name, values) => {
    setOpenDeleteModal(true);
    setDeleteItemId(values.id);
  };

  const prepareTableRows = () => {
    let item = {};
    const Arr = [];
    let keys = [];
    const d = [];
    for (let i = 0; i < PagesCount(+celebrityProductsMeta.filter_count, limit); i += 1) {
      d.push(i);
    }
    setPageOption(d);
    if (celebrityProducts && celebrityProducts.length !== 0) {
      celebrityProducts.forEach((product) => {
        item = {};
        keys = Object.keys(product);
        keys.forEach((element) => {
          item[element] = product[element];
        });

        item.title = product.product_id.arabic_title;
        item.action = (
          <>
            <MDTypography
              style={{ padding: 20, color: "#3b94ee" }}
              component="a"
              href="#"
              variant="caption"
              color="text"
              fontWeight="medium"
              onClick={() => onUpdateHandler("celebrityProducts", product)}
            >
              <Icon fontSize="small">edit</Icon>
            </MDTypography>
            <MDTypography
              style={{ padding: 20, color: "#e9423f" }}
              component="a"
              href="#"
              variant="caption"
              color="text"
              fontWeight="medium"
              onClick={() => onDeleteHandler("celebrityProducts", product)}
            >
              <Icon fontSize="small">delete</Icon>
            </MDTypography>
          </>
        );
        Arr.push(item);
      });
      setNewArr(Arr);
      console.log(Arr);
    } else {
      setNewArr([]);
    }
  };

  const setPageNumber = (num) => {
    if (num) {
      setPageNum(num);

      const url = `items/celebrity_products?fields=id,sequence,product_id.arabic_title,product_id.id,celebrity_id.first_name,celebrity_id.id&filter[celebrity_id]=${celebrityId}&meta=*&limit=${limit}&page=${num}`;
      dispatch(
        fetchDataAction({
          url,
          varName: "celebrityProducts",
        })
      );
    }
  };

  const setPayload = (values) => {
    const payloadData = {};
    const lastData = values.id ? UpdateRecord(values, initialValues) : values;

    Object.keys(lastData).forEach((key) => {
      if (lastData[key] && typeof lastData[key] === "object") payloadData[key] = lastData[key].id;
      else if (values.id || lastData[key]) payloadData[key] = lastData[key];
    });

    const req = {
      id: values.id,
      file: null,
      origin: {
        data: Object.keys(payloadData).length === 0 ? null : payloadData,
        table: "celebrity_products",
      },
      getInfo: {
        url: `items/celebrity_products?fields=id,sequence,product_id.arabic_title,product_id.id,celebrity_id.first_name,celebrity_id.id&filter[celebrity_id]=${celebrityId}&meta=*&limit=${limit}&page=${pageNum}`,
        varName: "celebrityProducts",
      },
    };
    dispatch(addComplexDataAction(req));
  };

  const handleConfirmDelete = async () => {
    const payload = {
      url: "items/celebrity_products",
      data: {
        id: deleteItemId,
        status: "deleted",
      },
      getInfo: {
        url: `items/celebrity_products?fields=id,sequence,product_id.arabic_title,product_id.id,celebrity_id.first_name,celebrity_id.id&filter[celebrity_id]=${celebrityId}&meta=*&limit=${limit}&page=${pageNum}`,
        varName: "celebrityProducts",
      },
    };
    dispatch(deleteDataAction(payload));
    setOpenDeleteModal(false);
  };

  useEffect(() => {
    if (resStatus && resStatus === "success") {
      resetForm();
    }
  }, [resStatus]);

  useEffect(
    () => () => {
      setNewArr([]);
      dispatch(reset(null));
    },
    []
  );

  useEffect(() => {
    dispatch(
      fetchDataAction({
        url: `items/celebrity_products?fields=id,sequence,product_id.arabic_title,product_id.id,celebrity_id.first_name,celebrity_id.id&filter[celebrity_id]=${celebrityId}&meta=*&limit=${limit}&page=${pageNum}`,
        varName: "celebrityProducts",
      })
    );

    dispatch(
      fetchDataAction({
        url: "items/products?fields=id,arabic_title&filter[parent_id][null]",
        varName: "celeAllProducts",
      })
    );
  }, [limit]);

  useEffect(() => {
    if (celebrityProducts && celebrityProducts.length !== 0) {
      prepareTableRows();
    }
  }, [celebrityProducts]);

  useEffect(() => {
    if (celeAllProducts) orgData();
  }, [celeAllProducts]);

  if (data.length === 0 || newArr === [] || !celebrityProductsMeta) {
    return null;
  }

  return (
    <Main
      // layout="simple"
      allRowsCount={+celebrityProductsMeta.filter_count}
      pageIndex={pageNum - 1}
      count={pageOptions}
      setPageNum={setPageNumber}
      setOpenDeleteModal={setOpenDeleteModal}
      openDeleteModal={openDeleteModal}
      handleConfirmDelete={handleConfirmDelete}
      name="celebrityProducts"
      setPayload={setPayload}
      data={data}
      entriesPerPage={false}
      initialValues={initialValues}
      title="Add Library Categories"
      columns={dataVal.columns}
      rows={newArr}
      onUpdateHandler={onUpdateHandler}
      onDeleteHandler={onDeleteHandler}
      yupObj={{
        product_id: yup.mixed("Enter your product").required("product is required").nullable(),
      }}
    />
  );
};
CelebrityProducts.propTypes = {
  celebrityId: PropTypes.number.isRequired,
};
export default CelebrityProducts;
